import { render, staticRenderFns } from "./ReceiptContent.vue?vue&type=template&id=0f055e9f&scoped=true"
import script from "./ReceiptContent.vue?vue&type=script&lang=js"
export * from "./ReceiptContent.vue?vue&type=script&lang=js"
import style0 from "./ReceiptContent.vue?vue&type=style&index=0&id=0f055e9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f055e9f",
  null
  
)

export default component.exports